import * as React from 'react';
import './Layout.scss'
import { Container } from 'reactstrap';
import NavMenu from './NavMenu';
import AlertBar from './Alertbar';
import Footer from './Footer';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore'
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess'
import { IconButton } from '@material-ui/core';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../store';
import { useWebSocket } from '../hooks/useWebSocket';
import { TawkChat } from '../components/TawkChat';
import { SystemNotesBanner } from '../components/SystemNotesModal';
import { clearSystemNotes } from '../store/session/actions';
import { PageWidthContext, usePageWidthState } from './PageWidthContext';

export default (props: { children?: React.ReactNode }) => {
    const location = useLocation()
    const dispatch = useDispatch()

    // Check if user is logged in
    const isLoggedIn = useSelector((state: ApplicationState) => !!state.session.user)
    const systemNotes = useSelector((state: ApplicationState) => state.session.user?.systemNotes ?? [])

    // Initialize WebSocket connection
    useWebSocket(isLoggedIn)

    const pageWidth = usePageWidthState()

    const headless = new URLSearchParams(location.search).get('headless')
    
    return headless ? (
        <>
            <AlertBar/>
            {props.children}
        </>
    ) : (
        <PageWidthContext.Provider value={pageWidth}>
            <SystemNotesBanner notes={systemNotes} onClose={() => dispatch(clearSystemNotes())} />
            <NavMenu/>
            <AlertBar/>
            <Container className="pageContainer" style={{maxWidth: pageWidth.fullWidth ? 'unset' : undefined, minHeight: '90vh'}}>
                {props.children}
            </Container>
            <Footer/>

            <IconButton onClick={pageWidth.toggleFullWidth} className='fullWidthFloatingButton'>
                {pageWidth.fullWidth ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
            </IconButton>

            <TawkChat />
        </PageWidthContext.Provider>
    )
}
